{
  "required": "Required",
  "promoCode": "Letters, digits and hyphens only",
  "promoCodeUnknown": "This code does not exist or can no longer be used",
  "promoCodeNotNow": "This code is not valid right now",
  "promoCodeNotForThisSale": "This code does not apply to this sale or customer",
  "promoCodeUsedUp": "This code has been used up",
  "promoCodeTaken": "Another promotion already has this code",
  "packComponents": "A pack holds at least two pieces, each product once",
  "packOverlap": "A product and one of its variants cannot be in the same pack",
  "packRetail": "A pack is for retail sales only",
  "minLength_one": "At least {{count}} character",
  "minLength_other": "At least {{count}} characters",
  "maxLength_one": "At most {{count}} character",
  "maxLength_other": "At most {{count}} characters",
  "min": "Must be {{min}} or more",
  "max": "Must be {{max}} or less",
  "email": "Enter a valid email, for example name@company.tn",
  "url": "Enter a valid website, for example www.company.tn",
  "format": "This format is not valid",
  "invalid": "This value is not valid",
  "invalidId": "Invalid identifier",
  "phone": "Use digits, spaces and an optional +, for example +216 71 000 000",
  "timezone": "Unknown time zone",
  "time": "Use the HH:MM format, for example 07:00",
  "maxThreeDecimals": "Use at most 3 decimals, for example 12.500",
  "maxTwoDecimals": "Use at most 2 decimals",
  "duplicates": "Each value only once",
  "emptyUpdate": "Nothing to save",
  "prefixFormat": "2 to 6 capital letters, for example REC",
  "prefixTaken": "Already used by a document type, a channel or a register",
  "usernameFormat": "Lowercase letters, digits, dots and dashes only",
  "usernameTaken": "This username is already used",
  "emailTaken": "This email is already used by another person",
  "nameTaken": "This name is already used",
  "passwordSameAsCurrent": "Choose a different password from the current one",
  "passwordsDiffer": "The two passwords are different",
  "currentPasswordWrong": "The current password is not correct",
  "locationsRequired": "Pick at least one location",
  "defaultLocationNotAssigned": "The default location must be one of the assigned locations",
  "languageNotEnabled": "Enable this language in Configuration first",
  "defaultLanguageRequired": "The company default language must stay enabled",
  "invalidPermission": "Unknown permission",
  "number": "Enter a valid number",
  "skuFormat": "Capital letters, digits, dots, dashes and slashes, up to 40 characters",
  "skuTaken": "This SKU already belongs to another product",
  "barcodeFormat": "Letters, digits and dashes only, 3 to 48 characters",
  "barcodeCheckDigit": "The last digit is wrong: check the barcode",
  "barcodeTaken": "This barcode already belongs to another product",
  "maxBelowMin": "The maximum must be at least the minimum",
  "unitDecimals": "The unit does not allow that many decimals",
  "inactiveValue": "Missing or deactivated: choose another value",
  "locationCode": "2 to 12 capital letters, digits or dashes, for example MAIN",
  "codeTaken": "Another location already uses this code",
  "date": "Enter a valid date",
  "tooManyLines": "Too many lines for one operation",
  "locationNotAllowed": "You cannot work in this location",
  "otherSite": "Choose a place inside the site of the operation",
  "noLines": "Add at least one product",
  "productArchived": "This product is archived: restore it first",
  "reasonIncreaseOnly": "This reason only adds stock",
  "reasonDecreaseOnly": "This reason only removes stock",
  "sameLocation": "Choose another place than the source",
  "moreThanSent": "More than what is still expected",
  "nothingReceived": "Enter what arrived",
  "notInCount": "Not part of this count",
  "duplicate": "Already in the list",
  "optionCode": "1 to 8 letters or digits",
  "color": "A colour like #1E88E5",
  "variantValues": "Choose one value of each option",
  "variantLocked": "An existing variant keeps its values",
  "variantInUse": "Used by variants: it cannot be removed",
  "variantMissing": "Every existing variant must stay in the list",
  "variantStock": "The stock must be zero in every location to archive this variant",
  "skuLocked": "The SKU cannot change once it has moved",
  "noPrice": "This product has no selling price",
  "discountTooLarge": "More than the line itself",
  "positive": "Must be more than zero",
  "tooLittle": "Less than the amount to pay",
  "methodNotAllowed": "This channel does not take this method",
  "inUse": "In use: it cannot change any more",
  "moreThanDrawer": "More than the drawer holds",
  "keptTooMuch": "More than what was counted",
  "slug": "Lowercase letters, digits and dashes (perceuse-18v)",
  "slugTaken": "This address is already used",
  "variantOnline": "A variant is published with its product",
  "galleryFull": "The gallery is full",
  "origin": "A web address like https://shop.example.tn",
  "parkedFull": "Too many tickets put aside at this register",
  "notOnSale": "Off sale for now",
  "notOnline": "Not sold in the online store",
  "variantOnly": "Only a variant is shown or hidden online on its own",
  "notPayable": "Only a validated receipt can be paid.",
  "otherSupplier": "This receipt is from another supplier.",
  "moreThanOpen": "More than what is left to pay on this receipt.",
  "moreThanPayment": "More than the payment.",
  "allocateAll": "Give the whole amount to the receipt: a supplier that is not registered cannot hold an advance.",
  "deferredPending": "A credit is settled later: record it as pending.",
  "noWholesalePrice": "No wholesale price: set it on the product, or sell it in retail mode.",
  "priceAboveReference": "Above the list price: change the product's price instead.",
  "trackingUrl": "Enter a web address starting with https:// that contains {tracking}",
  "percent": "At most 100 %",
  "endBeforeStart": "The last day comes before the first",
  "tiers": "Quantities must go up from one level to the next",
  "noOrders": "Choose at least one order",
  "shareAll": "Share the whole amount over the orders.",
  "moreThanDue": "More than what is still due on this order.",
  "futureDate": "This date is still to come",
  "tillToday": "A register takes today’s money only.",
  "invoiceOrder": "Invoice dates must follow their numbers: this day falls before the invoice before it, or after the one after it."
}
